// extracted by mini-css-extract-plugin
module.exports = {"list__item":"categories-list_list__item__3OsBg","list__item-palette-light":"categories-list_list__item-palette-light__3SMu5","accounts-link":"categories-list_accounts-link__u9Pxi"};